module.exports = __webpack_public_path__ + "img/bg_news.98ab8dae.jpg";